module.exports = __webpack_public_path__ + "assets/dragdots.74b547b2.svg";